import axiosBase from "@/api/axiosBase";

const state = {
  user: "",
  userAvatar: "",
  userList: [],
  resource: "",
  resourceHistory: "",
  storage: ""

}

const mutations = {

  setGetUserData(state, data) {
    state.user = data
  },

  setGetUserAvatar(state, data) {
    state.userAvatar = data
  },

  setGetUserDataList(state, data) {
    state.userList = data
  },

  setUpdateUserData(state, data) {
    state.user = data
  },

  setGetResource(state, data) {
    state.resource = data
  },

  setGetResourceHistory(state, data) {
    state.resourceHistory = data
  },

  setGetStorage(state, data) {
    state.storage = data
  }

}

const actions = {
  // 获取用户信息
  getUserData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/get'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetUserData', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取头像
  getUserAvatar({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/get_pic',
        responseType: "blob",
      }).then(res => {
        if (res.status != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetUserAvatar', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取用户列表
  getUserList({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/list?username=' + data.username + '&page=' + data.page + '&page_size=' + data.pageSize + '&sort_by=' + data.sort_by + '&sort_direction=' + data.sort_direction
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetUserData', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 修改用户信息
  updateUserData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/user/update',
        data: {
          "company": data.company,
          "education": data.education,
          "gender": data.gender,
          "motto": data.motto,
          "nickname": data.nickname,
          "phone": data.phone,
          "profession": data.profession,
          "region": data.region,
          "research": data.research,
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setUpdateUserData', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取资料信息
  getResource({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/rescource'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetResource', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取资料使用历史
  getResourceHistory({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/rescource_history'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetResourceHistory', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取存储详情信息
  getStorage({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/storage'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetStorage', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

}

const getters = {
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}